import * as tslib_1 from "tslib";
/* I76 in DS */
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
var Unlock = /** @class */ (function (_super) {
    tslib_1.__extends(Unlock, _super);
    function Unlock() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Unlock.prototype.render = function () {
        return (React.createElement(IconWrap, tslib_1.__assign({}, this.props),
            React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
                React.createElement("g", null,
                    React.createElement("path", { d: "M12.585 12H9.512a.514.514 0 0 0-.512.512v6.76c0 .283.23.514.512.514H21.29c.281 0 .512-.231.512-.513v-6.761c0-.28-.23-.512-.512-.512h-8.705zm4.655 3.62a1.62 1.62 0 1 1-3.24 0 1.62 1.62 0 0 1 3.24 0zM10.426 12V8.574a2.822 2.822 0 0 0-2.816-2.78 2.823 2.823 0 0 0-2.815 2.794c0-.014.02.505-.21.505H3.224c-.254 0-.223-.52-.223-.52a4.608 4.608 0 1 1 9.216 0V12h-1.79z" })))));
    };
    return Unlock;
}(React.Component));
export { Unlock };
export default Unlock;
//# sourceMappingURL=Unlock.js.map